import { FaRegUser } from "react-icons/fa6";
import { CiShop } from "react-icons/ci";
import { SlLike, SlSettings } from "react-icons/sl";
import { GoMail } from "react-icons/go";
import { LuView } from "react-icons/lu";
import { MdOutlineRateReview, MdOutlineStorefront } from "react-icons/md";
import { FaRegAddressCard } from "react-icons/fa";
import { FiHome, FiPackage, FiShoppingBag, FiUsers, FiCreditCard } from "react-icons/fi";
import { ACCOUNT, MARKET } from "./marketplaceRoutes";

export const MARKET_LOGIN_PATH = `/Login?returnUrl=${encodeURIComponent(MARKET.HOME)}`;

const customerLinks = [
  { to: ACCOUNT.HOME, label: "My Profile", Icon: FaRegUser },
  { to: ACCOUNT.ORDERS, label: "Orders", Icon: CiShop },
  { to: ACCOUNT.SAVED, label: "Saved items", Icon: SlLike },
  { to: ACCOUNT.INBOX, label: "Inbox", Icon: GoMail },
  { to: ACCOUNT.RECENT, label: "Recently Viewed", Icon: LuView },
  { to: ACCOUNT.REVIEWS, label: "Pending Evaluation", Icon: MdOutlineRateReview },
  { to: ACCOUNT.ADDRESSES, label: "Address Book", Icon: FaRegAddressCard },
  { to: ACCOUNT.SETTINGS, label: "Settings", Icon: SlSettings },
];

const merchantLinks = [
  { to: "/merchant", label: "Merchant dashboard", Icon: FiHome },
  { to: "/merchant/products", label: "Products", Icon: FiPackage },
  { to: "/merchant/orders", label: "Orders", Icon: FiShoppingBag },
  { to: "/merchant/payments", label: "Payments", Icon: FiCreditCard },
  { to: "/merchant/account", label: "Account", Icon: FaRegUser },
];

const marketplaceAdminLinks = [
  { to: "/admin", label: "Admin dashboard", Icon: FiHome },
  { to: "/admin/products", label: "Products", Icon: FiPackage },
  { to: "/admin/merchants", label: "Merchants", Icon: MdOutlineStorefront },
  { to: "/admin/orders", label: "Orders", Icon: FiShoppingBag },
  { to: "/admin/customers", label: "Customers", Icon: FiUsers },
  { to: "/admin/settings", label: "Settings", Icon: SlSettings },
];

export const getMarketAccountMenu = (role) => {
  if (role === "merchant") {
    return { variant: "merchant", title: "Merchant", links: merchantLinks };
  }
  if (role === "marketplacemanager") {
    return { variant: "admin", title: "Marketplace admin", links: marketplaceAdminLinks };
  }
  return { variant: "customer", title: "Account", links: customerLinks };
};
